export default __webpack_public_path__ + "static/l1-half-circle-shape-688763e0d9bb6048a4b8b7ff8056089d.png";